import { render, staticRenderFns } from "./ChangePasswordComponent.vue?vue&type=template&id=5c643191"
import script from "./ChangePasswordComponent.vue?vue&type=script&lang=ts"
export * from "./ChangePasswordComponent.vue?vue&type=script&lang=ts"
import style0 from "./ChangePasswordComponent.vue?vue&type=style&index=0&id=5c643191&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../local-cache/custom/dba27c31aad935787bb275c3e5e4e957708f15386de599eff1db476022cd7e4c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports